import { combineReducers } from 'redux';
import OrderReducer from './reducer/OrderReducer';
const rootReducer = combineReducers({
  OrderState: OrderReducer,
});

export default rootReducer;
